"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("./utils");

var SEPARATOR = '#@#';
var SRC_REG = /\/\/lang\.alicdn\.com\//;
var LOCALE_REG = /_([-\w]+)\.js/;
var CONFIG = {
  appName: '',
  pseudoEnableCookieKey: '_lang',
  pseudoEnableCookieKeyValue: 'pd_KV'
};
var globalAppName = 'medusa_app_name';
var pseudoEnableFlag;
var $i18n = {
  /**
   * getConfig
   * @returns typeof CONFIG
   */
  getConfig: function getConfig() {
    return Object.assign({}, CONFIG);
  },

  /**
   * custom set config
   * @param conf
   */
  setConfig: function setConfig(conf) {
    var _conf = conf || {};

    Object.keys(CONFIG).forEach(function (k) {
      if (_conf[k] !== undefined) {
        CONFIG[k] = _conf[k];
      }
    });
  },

  /**
   * Produce the formatted string for displaying to the user
   * @param {string} key copy key
   * @param {string} defaultMessage default text placeholder
   * @param {Variable} variable template variables
   * @param {opts} opts allow custom configKey, default use window.flute_langs;
   * @return {string} translate text or default text
   */
  get: function get(key, defaultMessage, variable, opts) {
    if (!key) return '';
    defaultMessage = defaultMessage || key;
    var configKey = opts ? opts.customConfigKey : 'flute_langs';
    var config = (0, _utils.isObject)(window[configKey]) ? window[configKey] : {};
    var locale = '';
    var appName = CONFIG.appName || window[globalAppName] || '';

    if (key.indexOf(SEPARATOR) > 0) {
      var _key$split = key.split(SEPARATOR);

      appName = _key$split[0];
      key = _key$split[1];
    } // 多应用


    if (config[appName]) {
      config = config[appName];
    }

    if (!Object.keys(config).length) {
      // 美杜莎
      var scripts = document.scripts || [];
      Array.prototype.some.call(scripts, function (_ref) {
        var src = _ref.src;

        if (SRC_REG.test(src) && LOCALE_REG.test(src)) {
          var regResult = src.match(LOCALE_REG);
          locale = regResult && regResult.length > 0 ? regResult[1] : '';
          return locale;
        }

        return false;
      });

      if (appName && locale) {
        configKey = appName + "_" + locale.toLowerCase();
        config = (0, _utils.isObject)(window[configKey]) ? window[configKey] : {};
      }
    } // 空文案时也是用默认文案


    var defaultString = ((0, _utils.isUndefined)(config[key]) || config[key] === '' ? defaultMessage : config[key]) || '';

    if (variable && typeof variable === 'object') {
      // 支持字符串变量
      defaultString = defaultString.replace(/\{([^}]+)\}/g, function () {
        var propsName = arguments.length <= 1 ? undefined : arguments[1];

        if (typeof variable[propsName] === 'undefined') {
          return arguments.length <= 0 ? undefined : arguments[0];
        }

        return variable[propsName];
      });
    } // transform to mds pseudo format to output


    if (pseudoEnableFlag === undefined) {
      pseudoEnableFlag = (0, _utils.getCookie)(CONFIG.pseudoEnableCookieKey) === CONFIG.pseudoEnableCookieKeyValue;
    }

    if (pseudoEnableFlag) {
      return "##@@@" + key + "##" + appName + "@@@##" + defaultString;
    }

    return defaultString;
  }
};
var _default = $i18n;
exports.default = _default;